import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-a4c2ac4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "info cm-ui-mt10" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "text" }
const _hoisted_8 = { class: "text" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = ["title"]
const _hoisted_11 = { class: "info" }
const _hoisted_12 = { class: "text" }
const _hoisted_13 = { class: "text" }
const _hoisted_14 = {
  key: 0,
  class: "row"
}
const _hoisted_15 = { class: "rb-btn cm-ui-mt20 cm-ui-ml10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DetailsSubscribeBar = _resolveComponent("DetailsSubscribeBar")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ContentAdaptLayout = _resolveComponent("ContentAdaptLayout")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DetailsSubscribeBar, {
      "normal-permission-key": _ctx.PermissionFe.flow_monitor
    }, null, 8, ["normal-permission-key"]),
    _withDirectives((_openBlock(), _createBlock(_component_ContentAdaptLayout, { class: "container" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("label", {
            class: "row-label",
            title: _ctx.t('groupPolicySettings.flowEnableMonitor')
          }, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.t('groupPolicySettings.flowEnableMonitor')), 1)
          ], 8, _hoisted_2),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.strategy.switch,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.strategy.switch) = $event)),
              onChange: _ctx.setChangeStatus
            }, null, 8, ["modelValue", "onChange"])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", {
            class: "row-label",
            title: _ctx.t('groupPolicySettings.flowUpSpeed')
          }, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.t('groupPolicySettings.flowUpSpeed')), 1)
          ], 8, _hoisted_5),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_space, {
              size: 10,
              onChange: _ctx.setChangeStatus
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  disabled: !_ctx.strategy.switch,
                  class: "flow-input-size",
                  "controls-position": "right",
                  size: "small",
                  min: _ctx.uploadMinSpeed,
                  max: _ctx.maxSpeed,
                  modelValue: _ctx.strategy.up_speed,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.strategy.up_speed) = $event)),
                  modelModifiers: { number: true }
                }, null, 8, ["disabled", "min", "max", "modelValue"]),
                _createVNode(_component_el_select, {
                  disabled: !_ctx.strategy.switch,
                  size: "small",
                  class: "input-size",
                  modelValue: _ctx.strategy.up_unit,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.strategy.up_unit) = $event)),
                  modelModifiers: { number: true }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "KB",
                      value: _ctx.FlowUnits.KB
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      label: "MB",
                      value: _ctx.FlowUnits.MB
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["disabled", "modelValue"]),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.t('groupPolicySettings.flowPerSecond')), 1),
                _createElementVNode("span", _hoisted_8, [
                  _createVNode(_component_CmSvgIcon, {
                    name: "views/dashboard/_components/group-policy-settings/_components/_images/blue_tips",
                    class: "cm-ui-mr5",
                    monochrome: "",
                    "aria-hidden": false,
                    "aria-label": "tip"
                  }),
                  _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.flowMinLimitTip')), 1)
                ])
              ]),
              _: 1
            }, 8, ["onChange"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("label", {
            class: "row-label",
            title: _ctx.t('groupPolicySettings.flowDownSpeed')
          }, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.t('groupPolicySettings.flowDownSpeed')), 1)
          ], 8, _hoisted_10),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_el_space, {
              size: 10,
              onChange: _ctx.setChangeStatus
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  disabled: !_ctx.strategy.switch,
                  class: "flow-input-size",
                  "controls-position": "right",
                  size: "small",
                  min: _ctx.downloadMinSpeed,
                  max: _ctx.maxSpeed,
                  modelValue: _ctx.strategy.down_speed,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.strategy.down_speed) = $event)),
                  modelModifiers: { number: true }
                }, null, 8, ["disabled", "min", "max", "modelValue"]),
                _createVNode(_component_el_select, {
                  disabled: !_ctx.strategy.switch,
                  class: "input-size",
                  size: "small",
                  modelValue: _ctx.strategy.down_unit,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.strategy.down_unit) = $event)),
                  modelModifiers: { number: true }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "KB",
                      value: _ctx.FlowUnits.KB
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      label: "MB",
                      value: _ctx.FlowUnits.MB
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["disabled", "modelValue"]),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.t('groupPolicySettings.flowPerSecond')), 1),
                _createElementVNode("span", _hoisted_13, [
                  _createVNode(_component_CmSvgIcon, {
                    name: "views/dashboard/_components/group-policy-settings/_components/_images/blue_tips",
                    class: "cm-ui-mr5",
                    monochrome: "",
                    "aria-hidden": false,
                    "aria-label": "tip"
                  }),
                  _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.flowMinLimitTip')), 1)
                ])
              ]),
              _: 1
            }, 8, ["onChange"])
          ])
        ]),
        (_ctx.operateType !== _ctx.OperateType.read)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_el_button, {
                  class: "",
                  disabled: _ctx.calcBtnDisableStatus(),
                  size: "small",
                  type: "primary",
                  onClick: _ctx.handlerSave
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('common.save')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  onClick: _ctx.cancel
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('common.cancel')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })), [
      [_directive_loading, _ctx.loading]
    ])
  ], 64))
}